export class ReservationsTariffFilter{
        general: string;
    }